import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[blockNumbers]',
})
export class BlockNumbersDirective {
  private readonly el = inject<ElementRef<HTMLInputElement>>(ElementRef);
  private readonly ngControl = inject(NgControl, { optional: true });

  @HostListener('beforeinput', ['$event'])
  onBeforeInput(event: InputEvent): void {
    if (event.data && /\d/.test(event.data)) {
      event.preventDefault();
    }
  }

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;
    const sanitized = input.value.replace(/\d/g, '');

    if (sanitized !== input.value) {
      const pos = input.selectionStart ?? sanitized.length;
      const removedBeforeCursor = (input.value.slice(0, pos).match(/\d/g) || [])
        .length;

      input.value = sanitized;
      input.setSelectionRange(
        pos - removedBeforeCursor,
        pos - removedBeforeCursor,
      );
      this.ngControl?.control?.setValue(sanitized, { emitEvent: true });
    }
  }
}
